// extracted by mini-css-extract-plugin
export default {"melodyVideo":"ZI-z","isFullWidth":"_I-z","landingPageVideo":"aJ-z","play":"bJ-z","iframeVideo":"cJ-z","playHidden":"dJ-z","fullwidth":"eJ-z"};